import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import cx from 'classnames';

// Utils
import { ellipsifyText } from '@utils/string-helpers';

// UI
import { Button, ButtonColor, ButtonVariant, ButtonProps } from '@components/button';
import { Typography, TypographyVariant } from '@components/typography';
type Props = {
  text: string;
  maxLines?: number;
  maxLength?: number;
  className?: string;
  buttonClassName?: string;
  buttonContainerClassName?: string;
  showMoreLabel?: string;
  showLessLabel?: string;
  typographyVariant?: TypographyVariant;
  typographyVariantM?: TypographyVariant;
  testId?: string;
  buttonColor?: ButtonColor;
  buttonVariant?: ButtonVariant;
  highlightQuery?: string;
  highlightClassName?: string;
};
const checkOverflow = (textContainer: HTMLDivElement | null) => {
  if (textContainer) {
    return textContainer.offsetHeight < textContainer.scrollHeight;
  }
  return false;
};
export const ExpandableText: React.FC<Props> = t0 => {
  const $ = _c(68);
  const {
    text,
    maxLines: t1,
    maxLength: t2,
    className: t3,
    buttonClassName: t4,
    buttonContainerClassName: t5,
    showMoreLabel: t6,
    showLessLabel: t7,
    typographyVariant: t8,
    typographyVariantM: t9,
    testId: t10,
    buttonColor: t11,
    buttonVariant: t12,
    highlightQuery,
    highlightClassName: t13
  } = t0;
  const maxLines = t1 === undefined ? 8 : t1;
  const maxLength = t2 === undefined ? 550 : t2;
  const className = t3 === undefined ? "" : t3;
  const buttonClassName = t4 === undefined ? "" : t4;
  const buttonContainerClassName = t5 === undefined ? "" : t5;
  const showMoreLabel = t6 === undefined ? "show more" : t6;
  const showLessLabel = t7 === undefined ? "show less" : t7;
  const typographyVariant = t8 === undefined ? "body2" : t8;
  const typographyVariantM = t9 === undefined ? "body1" : t9;
  const testId = t10 === undefined ? "data" : t10;
  const buttonColor = t11 === undefined ? "primary" : t11;
  const buttonVariant = t12 === undefined ? "text" : t12;
  const highlightClassName = t13 === undefined ? "bg-secondary-xlight rounded px-1" : t13;
  const [showMoreButton, setExpandableTextButton] = React.useState(true);
  const [isOverflowing, setIsOverflowing] = React.useState(false);
  const overflowingText = React.useRef(null);
  let t14;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      if (checkOverflow(overflowingText.current)) {
        setIsOverflowing(true);
        return;
      }
      setIsOverflowing(false);
    };
    $[0] = t14;
  } else {
    t14 = $[0];
  }
  let t15;
  if ($[1] !== text) {
    t15 = [text];
    $[1] = text;
    $[2] = t15;
  } else {
    t15 = $[2];
  }
  React.useEffect(t14, t15);
  const shouldShowButton = isOverflowing || text.length > maxLength;
  let T0;
  let buttonProps;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[3] !== buttonClassName || $[4] !== buttonColor || $[5] !== buttonVariant || $[6] !== className || $[7] !== highlightClassName || $[8] !== highlightQuery || $[9] !== maxLength || $[10] !== maxLines || $[11] !== showMoreButton || $[12] !== testId || $[13] !== text || $[14] !== typographyVariant || $[15] !== typographyVariantM) {
    const displayText = showMoreButton ? ellipsifyText(text, maxLength) : text;
    if ($[26] !== buttonClassName || $[27] !== buttonColor || $[28] !== buttonVariant || $[29] !== maxLines || $[30] !== showMoreButton || $[31] !== testId) {
      const lineClampClass = showMoreButton ? {
        1: "line-clamp-1",
        2: "line-clamp-2",
        3: "line-clamp-3",
        4: "line-clamp-4",
        5: "line-clamp-5",
        6: "line-clamp-6",
        7: "line-clamp-7",
        8: "line-clamp-8",
        9: "line-clamp-9",
        10: "line-clamp-10",
        11: "line-clamp-11",
        12: "line-clamp-12"
      }[maxLines] || "line-clamp-8" : "";
      const computedVariant = buttonVariant === "outlined" ? "outlined" as const : buttonVariant;
      const computedColor = buttonVariant === "outlined" ? buttonColor === "secondary" ? "default" : buttonColor : buttonColor;
      let t24;
      if ($[34] !== buttonClassName) {
        t24 = cx("-mr-3", buttonClassName);
        $[34] = buttonClassName;
        $[35] = t24;
      } else {
        t24 = $[35];
      }
      let t25;
      if ($[36] !== showMoreButton) {
        t25 = () => setExpandableTextButton(!showMoreButton);
        $[36] = showMoreButton;
        $[37] = t25;
      } else {
        t25 = $[37];
      }
      const t26 = `${testId}-${showMoreButton ? "show-more" : "show-less"}`;
      let t27;
      if ($[38] !== computedColor || $[39] !== computedVariant || $[40] !== t24 || $[41] !== t25 || $[42] !== t26) {
        t27 = {
          className: t24,
          variant: computedVariant,
          color: computedColor,
          size: "sm" as const,
          onClick: t25,
          dataId: t26
        };
        $[38] = computedColor;
        $[39] = computedVariant;
        $[40] = t24;
        $[41] = t25;
        $[42] = t26;
        $[43] = t27;
      } else {
        t27 = $[43];
      }
      buttonProps = t27 as ButtonProps;
      t22 = cx(lineClampClass);
      $[26] = buttonClassName;
      $[27] = buttonColor;
      $[28] = buttonVariant;
      $[29] = maxLines;
      $[30] = showMoreButton;
      $[31] = testId;
      $[32] = buttonProps;
      $[33] = t22;
    } else {
      buttonProps = $[32];
      t22 = $[33];
    }
    t23 = overflowingText;
    T0 = Typography;
    t16 = typographyVariant;
    t17 = typographyVariantM;
    t18 = "p";
    if ($[44] !== className) {
      t19 = cx("whitespace-pre-wrap text-ellipsis", className);
      $[44] = className;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    t20 = testId;
    t21 = highlightQuery && highlightQuery.trim() !== "" ? displayText.split(new RegExp(`(${highlightQuery.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&")})`, "gi")).map((part, idx) => part.toLowerCase() === highlightQuery.toLowerCase() ? <span key={idx} className={highlightClassName}>{part}</span> : <React.Fragment key={idx}>{part}</React.Fragment>) : displayText;
    $[3] = buttonClassName;
    $[4] = buttonColor;
    $[5] = buttonVariant;
    $[6] = className;
    $[7] = highlightClassName;
    $[8] = highlightQuery;
    $[9] = maxLength;
    $[10] = maxLines;
    $[11] = showMoreButton;
    $[12] = testId;
    $[13] = text;
    $[14] = typographyVariant;
    $[15] = typographyVariantM;
    $[16] = T0;
    $[17] = buttonProps;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t20;
    $[23] = t21;
    $[24] = t22;
    $[25] = t23;
  } else {
    T0 = $[16];
    buttonProps = $[17];
    t16 = $[18];
    t17 = $[19];
    t18 = $[20];
    t19 = $[21];
    t20 = $[22];
    t21 = $[23];
    t22 = $[24];
    t23 = $[25];
  }
  let t24;
  if ($[46] !== T0 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t20 || $[52] !== t21) {
    t24 = <T0 variant={t16} variantM={t17} component={t18} className={t19} data-id={t20}>{t21}</T0>;
    $[46] = T0;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t22 || $[55] !== t23 || $[56] !== t24) {
    t25 = <div className={t22} ref={t23}>{t24}</div>;
    $[54] = t22;
    $[55] = t23;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== buttonContainerClassName || $[59] !== buttonProps || $[60] !== shouldShowButton || $[61] !== showLessLabel || $[62] !== showMoreButton || $[63] !== showMoreLabel) {
    t26 = shouldShowButton && <div className={cx("flex w-full", buttonContainerClassName)}><Button {...buttonProps}>{showMoreButton ? showMoreLabel : showLessLabel}</Button></div>;
    $[58] = buttonContainerClassName;
    $[59] = buttonProps;
    $[60] = shouldShowButton;
    $[61] = showLessLabel;
    $[62] = showMoreButton;
    $[63] = showMoreLabel;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t25 || $[66] !== t26) {
    t27 = <div><div>{t25}{t26}</div></div>;
    $[65] = t25;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  return t27;
};